<!--
 * @Description:
 * @Version:
 * @Autor: houchuanfang
 * @Date: 2022-03-30 15:31:50
 * @LastEditTime: 2023-04-28 15:14:20
-->
<template>
  <el-cascader v-model="value" :disabled="disabled" :placeholder="placeholder" :size="size" :options="options" :props="{ checkStrictly: changeonselect,expandTrigger:expandTrigger}" ref="treeDict"
    clearable @change="handleChange"></el-cascader>
</template>

<script>
export default {
  name: 'selectCategory',
  props: [
    'defaultValue',
    'placeholder',
    'expandTrigger',
    'codeType',
    'codeLevel',
    'size',
    'disabled',
    'changeonselect',
    'dictValue'
  ],
  data() {
    return {
      value: [],
      options: []
    };
  },
  watch: {
    defaultValue: {
      handler: function (val) {
        this.value = val;
      }
    },
    value: {
      handler(newVal, oldVal) {
        if (this.$refs.treeDict) {
          var children = this.$refs.treeDict.getCheckedNodes()
          if (children ?? children[0].children.length < 1) {   //判断有没有下级
            this.$refs.treeDict.dropDownVisible = false //监听值发生变化就关闭它
          }
        }
      },
      deep: true
    }
  },
  methods: {

    handleChange(value) {
      // console.log(value);
      this.$emit('setMValue', value);
      this.$emit('change', value);
    },
    async initDictData() {
      //根据字典Code, 初始化字典数组
      let _this = this;
      let url = `/api/app-jycy-sysdict/commonDictValue?dictCode=${this.codeType || 'job1'}`;
      if (this.dictValue) {
        url += `&dictValue=${this.dictValue}`;
      }
      if (this.codeLevel) {
        url += `&maxLevel=${this.codeLevel}`;
      }
      // let url = `/api/app-jycy-sysdict/commonDictValue?dictCode=${this.codeType}&dictValue=${this.dictValue}&maxLevel=${this.codeLevel}`;
      await this.$axios.get(url).then(response => {
        if (response.data.success) {
          _this.options = response.data.data;
        }
      });
    }
  },
  created() {
    this.initDictData();
    if (this.defaultValue) {
      for (let i = 0; i < this.defaultValue.length; i++) {
        if (this.defaultValue[i]) {
          this.value.push(this.defaultValue[i]);
        }
      }
    }
    // console.log(this.defaultValue)
    // console.log(this.value)
  }
};
</script>
